import Config from '../launch/config'
import Entity from '../entity/entity'
import {isDebug} from '../launch/utils'
// import Phaser from 'phaser'

export default class Star extends Entity {
    constructor(props) {
        const sizeSmall = 12
        const sizeMed = 15
        const sizeLarge = 20

        const sizeMap = {
            // Red/Orange, Class M/K/G
            [sizeSmall]: {
                colors: ['0xff9c1b', '0xff5e26'],
                scale: 0.15,
            },
            // Orange/Yellow, Class G/F
            [sizeMed]: {
                colors: ['0xffcc31', '0xffef38'],
                scale: 0.2,
            },
            // Yellow/Blu, Class O/B/A/F
            [sizeLarge]: {
                colors: ['0xfff95c', '0x65d5ff'],
                scale: 0.3,
            },
        }

        props.type = 'star'

        const randDiameter = Config.chance.pick([sizeSmall, sizeMed, sizeLarge])

        props.diameter = props.diameter || randDiameter
        props.fillColor =
            props.fillColor || Config.chance.pick(sizeMap[randDiameter].colors)

        super(props)

        this.starImage = Config.scene.add.image(this.x, this.y, 'starEntity')
        this.starImage.setScale(sizeMap[this.diameter].scale)
        this.starImage.setDepth(3)
        this.starImage[Config.namespace] = {type: 'star image'}
        this.starImage.setTint(this.fillColor)
    }

    destroy() {
        this.starImage.destroy()

        super.destroy()
    }

    update() {
        super.update()

        this.starImage.setVisible(this.discovered || isDebug)
        this.starImage.setTint(
            this.selected && (this.discovered || isDebug)
                ? 0x0ffffff
                : this.fillColor
        )
    }
}
